import ruleEditors from "./RuleEditorReducer";

const ruleEditor = {
    reducers: ruleEditors
}

export default ruleEditor;